<template>
  <header class="the-header" :class="{ mobile: configStore.isMobileLayout, 'index-up': isMobileNav }">
    <div v-if="deviceStore.isSupported" class="device-status">
      <div>{{ deviceStore.currentTime }}</div>
      <DeviceStatus />
    </div>
    <div class="header-container" :class="{ 'is-status-visible': deviceStore.isSupported }">
      <template v-if="configStore.isMobileLayout">
        <div class="the-header__inner">
          <!-- 로고, 테이블 번호 -->
          <div class="the-header__left">
            <div class="the-header__logo" :class="{ cashnote: isCashnote }" @dblclick="handleLogoDoubleClick">
              <template v-if="isCashnote">
                <img src="@/assets/images/logo-cashnote.png" alt="캐시노트 로고" />
              </template>
              <template v-else>
                <img
                  v-if="i18n.locale.value === LocaleLanguage.Ko"
                  src="@/assets/images/logo-ko.png"
                  alt="UP오더 로고"
                />
                <img v-else src="@/assets/images/logo-en.png" alt="UP Order Logo" />
              </template>
            </div>
            <p class="table-info__name">{{ configStore.serverConfig?.TableName }}</p>
          </div>

          <div class="the-header__right">
            <!-- 다국어 선택 -->
            <BaseSelectLanguageMobile />
          </div>
        </div>

        <nav class="the-header__nav-mobile">
          <MenuGroupSlider :menu-groups="menuStore.filteredMenuGroups" />
        </nav>
      </template>
      <template v-else>
        <div class="the-header__inner">
          <div class="the-header__left">
            <div class="the-header__logo" :class="{ cashnote: isCashnote }" @dblclick="handleLogoDoubleClick">
              <template v-if="isCashnote">
                <img src="@/assets/images/logo-cashnote.png" alt="캐시노트 로고" />
              </template>
              <template v-else>
                <img
                  v-if="i18n.locale.value === LocaleLanguage.Ko"
                  src="@/assets/images/logo-ko.png"
                  alt="UP오더 로고"
                />
                <img v-else src="@/assets/images/logo-en.png" alt="UP오더 로고" />
              </template>
            </div>

            <!-- 테이블명 -->
            <p class="table-info__name">{{ configStore.serverConfig?.TableName }}</p>
          </div>

          <!-- 메뉴그룹 -->
          <nav class="the-header__gnb" :class="{ slider: configStore.config.MenuGroupType === 'slider' }">
            <template v-if="configStore.config.MenuGroupType === 'scroll'">
              <MenuGroupScroll :menu-groups="menuStore.filteredMenuGroups" />
            </template>
            <template v-else>
              <MenuGroupSlider :menu-groups="menuStore.filteredMenuGroups" />
            </template>
          </nav>
        </div>
      </template>
    </div>
  </header>
</template>

<script setup lang="ts">
  import BaseSelectLanguageMobile from '@/components/base/BaseSelectLanguageMobile.vue';
  import DeviceStatus from '@/components/DeviceStatus.vue';
  import MenuGroupScroll from '@/components/MenuGroupScroll.vue';
  import MenuGroupSlider from '@/components/MenuGroupSlider.vue';
  import { LocaleLanguage } from '@/enums/LocaleLanguage';
  import { useConfigStore } from '@/stores/config';
  import { useDeviceStore } from '@/stores/device';
  import { useMenuStore } from '@/stores/menu';
  import { useModalStore } from '@/stores/modal';
  import { computed, ref } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useRoute } from 'vue-router';

  const i18n = useI18n();
  const route = useRoute();
  const configStore = useConfigStore();
  const modalStore = useModalStore();
  const menuStore = useMenuStore();
  const deviceStore = useDeviceStore();

  const isMobileNav = ref(false);

  const isCashnote = computed(() => {
    return configStore.config.ManageCompany === 'KPN' || configStore.config.ManageCompany === 'KCD';
  });

  /** 로고 더블클릭 */
  const handleLogoDoubleClick = () => {
    if (route.params.StoreID) return;
    modalStore.openAdminAuthModal();
  };
</script>

<style lang="scss">
  .the-header {
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    background: #f6f6f6;
    z-index: 1;

    .device-status {
      display: flex;
      justify-content: space-between;
      padding: 0.3906vw 1.4925vw;
      color: var(--text-contrast-color);
      font-size: 1.0938vw;
    }

    .header-container {
      padding: 1.5625vw 0;
      &.is-status-visible {
        padding: 0.3906vw 0 1.5625vw 0;
      }
    }

    .the-header__inner {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .the-header__left {
      display: flex;
      justify-content: center;
      align-items: center;
      //width: 25.1806vw;
    }
    .the-header__logo {
      position: relative;
      display: flex;
      margin-left: -1.4925vw;
      height: 4.4776vw;
      img {
        width: 9.7015vw;
        height: fit-content;
        margin-top: -0.7463vw;
        vertical-align: baseline;
      }
      &.cashnote {
        margin: 0 0.7463vw;
        height: auto;
        img {
          width: 3.7313vw;
          margin-top: 0;
        }
      }
    }
    .table-info__name {
      position: relative;
      max-width: 16.9806vw;
      color: #fff;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      word-break: break-all;
      font-size: 2.9851vw;
      font-weight: 500;
      color: #000;
    }
    .the-header__gnb {
      width: calc(100% - 25.1806vw);
      padding-right: 3.3582vw;
    }
  }

  // Dark Mode
  .dark-theme {
    .the-header {
      background: url('@/assets/images/bg-home.jpg') no-repeat top center;
      background-size: cover;
    }
    .gnb__ul {
      & > li > a {
        background: transparent;
        border: none;
        color: #fff;
      }
      & > li > a.active {
        background: var(--brand-primary);
        box-shadow: none;
      }
    }
    .table-info__name {
      color: #fff;
    }
  }

  .dark-gray-theme {
    .the-header {
      background-color: #1e1f1d;
    }
    .gnb__ul {
      & > li > a {
        background: transparent;
        border: none;
        color: #fff;
      }
      & > li > a.active {
        background: var(--brand-primary);
        box-shadow: none;
      }
    }
    .table-info__name {
      color: #fff;
    }
  }

  .green-theme {
    .gnb__ul {
      & > li > a {
        background: transparent;
        border: none;
        color: #fff;
      }
      & > li > a.active {
        background: var(--brand-primary);
        box-shadow: none;
      }
    }
    .table-info__name {
      color: #000;
    }
  }

  .blue-theme {
    .the-header {
      background: var(--bg-black);
      background-size: cover;
    }
    .gnb__ul {
      & > li > a {
        background: transparent;
        border: none;
        color: #fff;
      }
      & > li > a.active {
        background: var(--brand-primary);
        box-shadow: none;
      }
    }
    .table-info__name {
      color: #fff;
    }
  }

  .light-blue-theme {
    .the-header {
      background: var(--bg-black);
      background-size: cover;
    }
    .gnb__ul {
      & > li > a {
        background: transparent;
        border: none;
        color: #fff;
      }
      & > li > a.active {
        background: var(--brand-primary);
        box-shadow: none;
      }
    }
    .table-info__name {
      color: #fff;
    }
  }

  // Todo: (Add) CSS 추가
  .the-header.mobile {
    background: #20272b;
    &.index-up {
      z-index: 1020;
    }
    .the-header__inner {
      align-items: center;
      height: 56px;
      padding: 0 10px;
      .the-header__left {
        height: 100%;
        align-items: center;
        gap: 5px;
      }
    }
    .the-header__logo {
      margin-left: -22px;
      height: 100%;
      img {
        width: 80px;
        margin-top: 7px;
      }
      &.cashnote {
        margin-left: 0;
        height: auto;
        img {
          width: 25px;
          margin-top: 0;
        }
      }
    }
    .table-info__name {
      position: static;
      height: auto;
      font-size: 16px;
      margin-left: inherit;
      color: #fff;
    }
    .the-header__right {
      display: flex;
      align-items: center;
      .menu-box {
        display: flex;
        flex-direction: column;
        padding: 1.4925vw;
        span {
          width: 20px;
          height: 2px;
          background: #fff;
        }

        span + span {
          margin-top: 4px;
        }
      }
    }

    .utility__language {
      position: relative;
      margin-right: 20px;
      .language__current {
        display: flex;
        align-items: center;
        .current__text {
          font-size: 14px;
          margin-right: 6px;
          color: #fff;
        }
        img {
          width: 10px;
          transform: rotate(180deg);
        }
      }
      .language__ul {
        position: absolute;
        top: -6px;
        left: -6px;
        z-index: 4;
        padding: 6px;
        background: #fff;
        border: 1px solid #000;
        border-radius: 6px;
        li {
          display: flex;
          align-items: center;
        }
        li + li {
          margin-top: 6px;
        }
        .current__text {
          font-size: 14px;
          margin-right: 6px;
          white-space: nowrap;
          & + img {
            width: 10px;
            transform: rotate(180deg);
          }
        }
      }
      .language__backdrop {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        height: 100vh;
      }
    }
    .the-header__nav-mobile {
      background: #fff;
      padding: 6px 0;
      .gnb-slider .gnb-slider__item {
        font-size: 16px;
        height: 30px;
      }
    }
    .nav__backdrop {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100vh;
      z-index: 1030;
      background: rgba(0, 0, 0, 0.6);
    }
  }

  .dark-theme,
  .dark-gray-theme {
    .the-header.mobile {
      .the-header__nav-mobile {
        background: #000;
      }
    }
  }
</style>
